import { render, staticRenderFns } from "./Categoria.vue?vue&type=template&id=58d07d86&scoped=true"
import script from "./Categoria.vue?vue&type=script&lang=js"
export * from "./Categoria.vue?vue&type=script&lang=js"
import style0 from "./Categoria.vue?vue&type=style&index=0&id=58d07d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d07d86",
  null
  
)

export default component.exports